// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeLineStyle_pageHeader__l3Od5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
.timeLineStyle_pageHeader__l3Od5 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr {
  display: flex;
  align-items: center;
  gap: 20px;
}
.timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr .timeLineStyle_date__F6GE- {
  display: flex;
  align-items: center;
  gap: 4px;
}
.timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr .timeLineStyle_date__F6GE- img,
.timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr .timeLineStyle_date__F6GE- svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr .timeLineStyle_date__F6GE- span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.timeLineStyle_selectableUserAvatarContainer__7iCHJ {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px;
}

.timeLineStyle_schedulerWrap__Hdg3l {
  padding: 0 24px;
}

@media (max-width: 767px) {
  .timeLineStyle_pageHeader__l3Od5 {
    padding: 16px;
  }
  .timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr {
    gap: 12px;
  }
  .timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
  .timeLineStyle_selectableUserAvatarContainer__7iCHJ {
    padding: 16px;
  }
  .timeLineStyle_schedulerWrap__Hdg3l {
    padding: 16px;
  }
}
@media (max-width: 425px) {
  .timeLineStyle_pageHeader__l3Od5 .timeLineStyle_right__2F7mr .timeLineStyle_date__F6GE- span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/timeline/timeLineStyle.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AAJD;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC;IACC,aAAA;EAJA;EAMA;IACC,SAAA;EAJD;EAMC;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAJF;EASD;IACC,aAAA;EAPA;EAUD;IACC,aAAA;EARA;AACF;AAWA;EAII;IACC,aAAA;EAZH;AACF","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.selectableUserAvatarContainer {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 24px;\r\n\tpadding: 24px;\r\n}\r\n\r\n.schedulerWrap {\r\n\tpadding: 0 24px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageHeader {\r\n\t\tpadding: 16px;\r\n\r\n\t\t.right {\r\n\t\t\tgap: 12px;\r\n\r\n\t\t\tbutton {\r\n\t\t\t\tmin-height: 35px;\r\n\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\tfont-size: 12px;\r\n\t\t\t\ttext-align: center;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.selectableUserAvatarContainer {\r\n\t\tpadding: 16px;\r\n\t}\r\n\r\n\t.schedulerWrap {\r\n\t\tpadding: 16px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageHeader {\r\n\t\t.right {\r\n\t\t\t.date {\r\n\t\t\t\tspan {\r\n\t\t\t\t\tdisplay: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `timeLineStyle_pageHeader__l3Od5`,
	"right": `timeLineStyle_right__2F7mr`,
	"date": `timeLineStyle_date__F6GE-`,
	"selectableUserAvatarContainer": `timeLineStyle_selectableUserAvatarContainer__7iCHJ`,
	"schedulerWrap": `timeLineStyle_schedulerWrap__Hdg3l`
};
export default ___CSS_LOADER_EXPORT___;
